module.exports = __webpack_public_path__ + "img/LEGEND_THREE_A1014.805a8b75.png";